/**
 * 购物车模块
 **/
import {joinShoppingCart, listShoppingCart, removeShoppingCart} from "@api/shopping-api";

import {ADD_CART, INIT_CART_LIST, REMOVE_CART} from "@constants/action-type/cart-action-type";
import {showSuccess, showSuccessMsg} from "@utils/msg";
import {Modal} from "ant-design-vue";
import {
    ADD_CART_SELECTED,
    CHANGE_CART_SELECTED,
    REMOVE_CART_SELECTED
} from "@constants/mutation-type/cart-mutation-type";

export default {
    namespaced: true,
    state: {
        cartList: [],
        selectList: [],
        isLoading: false
    },
    getters: {
        indeterminate(state) {
            return state.selectList.length > 0 && state.selectList.length < state.cartList.length;
        },
        checkAll(state) {
            return state.selectList.length > 0 && state.selectList.length === state.cartList.length;
        },
        total(state) {
            return state.cartList.length
        },
        totalPrice(state) {
            let total = 0;
            state.selectList.forEach(item => {
                if (item.course.isDiscount === '0' || item.course.isDiscount === 0) {
                    // 原价
                    total += item.course.coursePrice;
                } else {
                    // 打折
                    total += item.course.discountPrice;
                }
            });
            return total.toFixed(2)
        }
    },
    mutations: {
        setLoading(state, payload) {
            state.isLoading = payload.isLoading
        },
        initCartList(state, payload) {
            state.cartList = payload.cartList.concat();
            state.isLoading = false;
        },
        [ADD_CART_SELECTED](state, payload) {
            const selectList = state.selectList.concat();
            selectList.push(payload.cartInfo);
            state.selectList = selectList;
        },
        [REMOVE_CART_SELECTED](state, payload) {
            let index = state.selectList.findIndex(item => {
                return payload.shoppingCartId === item.shoppingCartId
            });
            if (index !== -1) {
                const selectList = state.selectList.concat();
                selectList.splice(index, 1);
                state.selectList = selectList;
            }
        },
        [CHANGE_CART_SELECTED](state, payload) {
            state.selectList = payload.selectList.concat();
        }
    },

    actions: {
        [INIT_CART_LIST]({commit}) {
            commit({
                type: 'setLoading',
                isLoading: true
            });
            return new Promise(resolve => {
                listShoppingCart().then(res => {
                    if (res.code === 0) {
                        commit({
                            type: 'initCartList',
                            cartList: res.shoppingCartList
                        })
                    }
                    resolve(res);
                })
            })
        },
        [ADD_CART]({dispatch}, {courseId}) {
            return new Promise(resolve => {
                joinShoppingCart(courseId).then(res => {
                    if (res.code === 0) {
                        showSuccess("通知", "成功添加到购物车");
                        dispatch(INIT_CART_LIST);
                    }
                    resolve(res)
                })
            })
        },
        [REMOVE_CART]({dispatch}, {shoppingCartId, courseName}) {
            Modal.confirm({
                title: '确定删除吗?',
                content: `您确定要删除${courseName}吗？`,
                okText: '删除',
                okType: 'danger',
                cancelText: '取消',
                onOk() {
                    return new Promise(resolve => {
                        removeShoppingCart(shoppingCartId).then(res => {
                            if (res.code === 0) {
                                showSuccessMsg("删除成功");
                                dispatch(INIT_CART_LIST);
                            }
                            resolve()
                        });
                    })
                },
            });

        }
    }
}
